import {
  BaseTelemetryPlugin,
  SeverityLevel,
  __assignFn,
  __extendsFn,
  _throwInternal,
  arrForEach,
  dateNow,
  dynamicProto,
  isFunction,
  objDefineAccessors,
  proxyFunctions,
  safeGetCookieMgr
} from "./chunk-QJXNZHKV.js";
import {
  require_react
} from "./chunk-KJIRP3BF.js";
import {
  __toESM
} from "./chunk-J43GMYXM.js";

// node_modules/.pnpm/@microsoft+applicationinsights-react-js@3.4.0_history@5.3.0+react@18.2.0/node_modules/@microsoft/applicationinsights-react-js/dist-esm/ReactPlugin.js
var ReactPlugin = function(_super) {
  __extendsFn(ReactPlugin2, _super);
  function ReactPlugin2() {
    var _this = _super.call(this) || this;
    _this.priority = 185;
    _this.identifier = "ReactPlugin";
    var _analyticsPlugin;
    var _extensionConfig;
    var _unlisten;
    var _pageViewTimer;
    dynamicProto(ReactPlugin2, _this, function(_self, _base) {
      _initDefaults();
      _self.initialize = function(config, core, extensions, pluginChain) {
        _super.prototype.initialize.call(_this, config, core, extensions, pluginChain);
        _extensionConfig = config.extensionConfig && config.extensionConfig[_self.identifier] ? config.extensionConfig[_self.identifier] : { history: null };
        arrForEach(extensions, function(ext) {
          var identifier = ext.identifier;
          if (identifier === "ApplicationInsightsAnalytics") {
            _analyticsPlugin = ext;
          }
        });
        if (_extensionConfig.history) {
          _addHistoryListener(_extensionConfig.history);
          var pageViewTelemetry = {
            uri: _extensionConfig.history.location.pathname
          };
          _self.trackPageView(pageViewTelemetry);
        }
      };
      _self.getCookieMgr = function() {
        return safeGetCookieMgr(_self.core);
      };
      _self.getAppInsights = _getAnalytics;
      _self.processTelemetry = function(event, itemCtx) {
        _self.processNext(event, itemCtx);
      };
      _self._doTeardown = function(unloadCtx, unloadState, asyncCallback) {
        if (isFunction(_unlisten)) {
          _unlisten();
        }
        if (_pageViewTimer) {
          clearTimeout(_pageViewTimer);
        }
        _initDefaults();
      };
      proxyFunctions(_self, _getAnalytics, [
        "trackMetric",
        "trackPageView",
        "trackEvent",
        "trackException",
        "trackTrace"
      ]);
      function _initDefaults() {
        _analyticsPlugin = null;
        _extensionConfig = null;
        _unlisten = null;
        _pageViewTimer = null;
      }
      function _getAnalytics() {
        if (!_analyticsPlugin) {
          _throwInternal(_self.diagLog(), 1, 64, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
        return _analyticsPlugin;
      }
      function _addHistoryListener(history) {
        var locationListener = function(arg) {
          var locn = null;
          if ("location" in arg) {
            locn = arg["location"];
          } else {
            locn = arg;
          }
          _pageViewTimer = setTimeout(function() {
            _pageViewTimer = null;
            var pageViewTelemetry = { uri: locn.pathname };
            _self.trackPageView(pageViewTelemetry);
          }, 500);
        };
        _unlisten = history.listen(locationListener);
      }
      objDefineAccessors(_self, "_extensionConfig", function() {
        return _extensionConfig;
      });
    });
    return _this;
  }
  ReactPlugin2.__ieDyn = 1;
  return ReactPlugin2;
}(BaseTelemetryPlugin);
var ReactPlugin_default = ReactPlugin;

// node_modules/.pnpm/@microsoft+applicationinsights-react-js@3.4.0_history@5.3.0+react@18.2.0/node_modules/@microsoft/applicationinsights-react-js/dist-esm/withAITracking.js
var React = __toESM(require_react());
var AITrackedComponentBase = function(_super) {
  __extendsFn(AITrackedComponentBase2, _super);
  function AITrackedComponentBase2(props, reactPlugin, componentName) {
    var _this = _super.call(this, props) || this;
    _this._mountTimestamp = 0;
    _this._firstActiveTimestamp = 0;
    _this._idleStartTimestamp = 0;
    _this._lastActiveTimestamp = 0;
    _this._totalIdleTime = 0;
    _this._idleCount = 0;
    _this._idleTimeout = 5e3;
    _this.trackActivity = function(e) {
      if (_this._firstActiveTimestamp === 0) {
        _this._firstActiveTimestamp = dateNow();
        _this._lastActiveTimestamp = _this._firstActiveTimestamp;
      } else {
        _this._lastActiveTimestamp = dateNow();
      }
      if (_this._idleStartTimestamp > 0) {
        var lastIdleTime = _this._lastActiveTimestamp - _this._idleStartTimestamp;
        _this._totalIdleTime += lastIdleTime;
        _this._idleStartTimestamp = 0;
      }
    };
    _this._reactPlugin = reactPlugin;
    _this._componentName = componentName;
    return _this;
  }
  AITrackedComponentBase2.prototype.componentDidMount = function() {
    var _this = this;
    this._mountTimestamp = dateNow();
    this._firstActiveTimestamp = 0;
    this._totalIdleTime = 0;
    this._lastActiveTimestamp = 0;
    this._idleStartTimestamp = 0;
    this._idleCount = 0;
    this._intervalId = setInterval(function() {
      if (_this._lastActiveTimestamp > 0 && _this._idleStartTimestamp === 0 && dateNow() - _this._lastActiveTimestamp >= _this._idleTimeout) {
        _this._idleStartTimestamp = dateNow();
        _this._idleCount++;
      }
    }, 100);
  };
  AITrackedComponentBase2.prototype.componentWillUnmount = function() {
    if (this._mountTimestamp === 0) {
      throw new Error("withAITracking:componentWillUnmount: mountTimestamp is not initialized.");
    }
    if (this._intervalId) {
      clearInterval(this._intervalId);
    }
    if (this._firstActiveTimestamp === 0) {
      return;
    }
    var engagementTime = this.getEngagementTimeSeconds();
    var metricData = {
      average: engagementTime,
      name: "React Component Engaged Time (seconds)",
      sampleCount: 1
    };
    var additionalProperties = { "Component Name": this._componentName };
    this._reactPlugin.trackMetric(metricData, additionalProperties);
  };
  AITrackedComponentBase2.prototype.getEngagementTimeSeconds = function() {
    return (dateNow() - this._firstActiveTimestamp - this._totalIdleTime - this._idleCount * this._idleTimeout) / 1e3;
  };
  return AITrackedComponentBase2;
}(React.Component);
function withAITracking(reactPlugin, Component2, componentName, className) {
  if (componentName === void 0 || componentName === null || typeof componentName !== "string") {
    componentName = Component2.prototype && Component2.prototype.constructor && Component2.prototype.constructor.name || "Unknown";
  }
  if (className === void 0 || className === null || typeof className !== "string") {
    className = "";
  }
  return function(_super) {
    __extendsFn(class_1, _super);
    function class_1(props) {
      return _super.call(this, props, reactPlugin, componentName) || this;
    }
    class_1.prototype.render = function() {
      return React.createElement(
        "div",
        { onKeyDown: this.trackActivity, onMouseMove: this.trackActivity, onScroll: this.trackActivity, onMouseDown: this.trackActivity, onTouchStart: this.trackActivity, onTouchMove: this.trackActivity, className },
        React.createElement(Component2, __assignFn({}, this.props))
      );
    };
    return class_1;
  }(AITrackedComponentBase);
}

// node_modules/.pnpm/@microsoft+applicationinsights-react-js@3.4.0_history@5.3.0+react@18.2.0/node_modules/@microsoft/applicationinsights-react-js/dist-esm/AppInsightsErrorBoundary.js
var import_react = __toESM(require_react());
var AppInsightsErrorBoundary = function(_super) {
  __extendsFn(AppInsightsErrorBoundary2, _super);
  function AppInsightsErrorBoundary2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = { hasError: false };
    return _this;
  }
  AppInsightsErrorBoundary2.prototype.componentDidCatch = function(error, errorInfo) {
    this.setState({ hasError: true });
    this.props.appInsights.trackException({
      error,
      exception: error,
      severityLevel: SeverityLevel.Error,
      properties: errorInfo
    });
  };
  AppInsightsErrorBoundary2.prototype.render = function() {
    if (this.state.hasError) {
      var onError = this.props.onError;
      return import_react.default.createElement(onError);
    }
    return this.props.children;
  };
  return AppInsightsErrorBoundary2;
}(import_react.default.Component);
var AppInsightsErrorBoundary_default = AppInsightsErrorBoundary;

// node_modules/.pnpm/@microsoft+applicationinsights-react-js@3.4.0_history@5.3.0+react@18.2.0/node_modules/@microsoft/applicationinsights-react-js/dist-esm/AppInsightsContext.js
var import_react2 = __toESM(require_react());
var AppInsightsContext = (0, import_react2.createContext)(void 0);
var useAppInsightsContext = function() {
  return (0, import_react2.useContext)(AppInsightsContext);
};

// node_modules/.pnpm/@microsoft+applicationinsights-react-js@3.4.0_history@5.3.0+react@18.2.0/node_modules/@microsoft/applicationinsights-react-js/dist-esm/useTrackEvent.js
var import_react3 = __toESM(require_react());
function useCustomEvent(reactPlugin, eventName, eventData, skipFirstRun) {
  if (skipFirstRun === void 0) {
    skipFirstRun = true;
  }
  var _a = (0, import_react3.useState)(eventData), data = _a[0], setData = _a[1];
  var firstRun = (0, import_react3.useRef)(skipFirstRun);
  (0, import_react3.useEffect)(function() {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    reactPlugin.trackEvent({ name: eventName }, data);
  }, [reactPlugin, data, eventName]);
  return setData;
}

// node_modules/.pnpm/@microsoft+applicationinsights-react-js@3.4.0_history@5.3.0+react@18.2.0/node_modules/@microsoft/applicationinsights-react-js/dist-esm/useTrackMetric.js
var import_react4 = __toESM(require_react());
function getEngagementTimeSeconds(trackedData) {
  return (dateNow() - trackedData.firstActiveTimestamp - trackedData.totalIdleTime - trackedData.idleCount * trackedData.idleTimeout) / 1e3;
}
var useComponentTracking = function(reactPlugin, componentName, customProperties) {
  var tracking = (0, import_react4.useRef)({
    hookTimestamp: dateNow(),
    firstActiveTimestamp: 0,
    totalIdleTime: 0,
    lastActiveTimestamp: 0,
    idleStartTimestamp: 0,
    idleCount: 0,
    idleTimeout: 5e3
  });
  var savedCallback = (0, import_react4.useRef)();
  var callback = function() {
    var trackedData = tracking.current;
    if (trackedData.lastActiveTimestamp > 0 && trackedData.idleStartTimestamp === 0 && dateNow() - trackedData.lastActiveTimestamp >= trackedData.idleTimeout) {
      trackedData.idleStartTimestamp = dateNow();
      trackedData.idleCount++;
    }
  };
  var delay = 100;
  savedCallback.current = callback;
  (0, import_react4.useEffect)(function() {
    var id = setInterval(savedCallback.current, delay);
    return function() {
      clearInterval(id);
      var trackedData = tracking.current;
      if (trackedData.hookTimestamp === 0) {
        throw new Error("useAppInsights:unload hook: hookTimestamp is not initialized.");
      }
      if (trackedData.firstActiveTimestamp === 0) {
        return;
      }
      var engagementTime = getEngagementTimeSeconds(trackedData);
      var metricData = {
        average: engagementTime,
        name: "React Component Engaged Time (seconds)",
        sampleCount: 1
      };
      var additionalProperties = __assignFn({ "Component Name": componentName }, customProperties);
      reactPlugin.trackMetric(metricData, additionalProperties);
    };
  }, []);
  var trackActivity = function() {
    var trackedData = tracking.current;
    if (trackedData.firstActiveTimestamp === 0) {
      trackedData.firstActiveTimestamp = dateNow();
      trackedData.lastActiveTimestamp = trackedData.firstActiveTimestamp;
    } else {
      trackedData.lastActiveTimestamp = dateNow();
    }
    if (trackedData.idleStartTimestamp > 0) {
      var lastIdleTime = trackedData.lastActiveTimestamp - trackedData.idleStartTimestamp;
      trackedData.totalIdleTime += lastIdleTime;
      trackedData.idleStartTimestamp = 0;
    }
  };
  return trackActivity;
};
var useTrackMetric_default = useComponentTracking;
export {
  AITrackedComponentBase,
  AppInsightsContext,
  AppInsightsErrorBoundary_default as AppInsightsErrorBoundary,
  ReactPlugin_default as ReactPlugin,
  useAppInsightsContext,
  useCustomEvent as useTrackEvent,
  useTrackMetric_default as useTrackMetric,
  withAITracking
};
//# sourceMappingURL=@microsoft_applicationinsights-react-js.js.map
